class CadastrarContratoModal {
    constructor(gql, $scope, modal) {
        this.gql = gql
        this.modal = modal
        this.apply = fun => $scope.$apply(fun)

        this.certificado = {}
        this.empresa = {}
        this.filial = {}

        this.filiais = []

        $scope.$watch(
            () => this.empresa.cnpj,
            (cnpj, before) => {
                if (cnpj && cnpj !== before) {
                    this.empresa.raizCnpj = cnpj.slice(0, 8)

                    this.empresaPromise = Promise
                        .all([
                            this
                                .loadDadosCadastrais(cnpj)
                                .then(({ empresa }) =>
                                    this.empresa = {
                                        ...this.empresa,
                                        ...empresa
                                    }
                                ),
                            this
                                .verificaExistencia(cnpj.slice(0, 8))
                                .then(({ existe }) =>
                                    this.empresaForm.cnpj.$setValidity('existe', !existe)
                                )
                        ])
                        .then(() => this.apply())
                        .then(() => this.empresaSubmit())
                        .catch(console.error)
                        .finally(() => this.apply())
                }
            }
        )

        $scope.$watch(
            () => this.filial.finalCnpj,
            (finalCnpj, before) => {
                if (finalCnpj && finalCnpj !== before) {
                    this.filial.cnpj = `${this.empresa.raizCnpj}${finalCnpj.replace(/\D/g, '')}`
                }
            }
        )

        $scope.$watch(
            () => this.filial.cnpj,
            (cnpj, before) => {
                if (cnpj && cnpj !== before && cbk.validateCnpj(cnpj)) {
                    this.filialPromise = this
                        .loadDadosCadastrais(cnpj)
                        .then(({ empresa }) =>
                            this.filial = {
                                ...this.filial,
                                ...empresa
                            }
                        )
                        .then(() => this.apply())
                        .then(() => this.filialSubmit())
                        .catch(console.error)
                        .finally(() => this.apply())
                }
            }
        )
    }

    loadDadosCadastrais(cnpj) {
        const query = gql`
            query DadosCadastrais($cnpj: String!) {
                empresa: dadosCadastrais(cnpj: $cnpj) {
                    razaoSocial
                    cnpj
                    cidade {
                        id
                        nome
                        estado {
                            id
                            sigla
                        }
                    }
                }
            }
        `

        return this.gql.query(query, { cnpj })
    }

    verificaExistencia(raizCnpj) {
        const query = gql`
            query DadosCadastrais($raizCnpj: String!) {
                existe: existenciaEmpresa(raizCnpj: $raizCnpj)
            }
        `

        return this.gql.query(query, { raizCnpj })
    }

    loadCidades(search) {
        const query = gql`
            query Cidades($nomeSearch: String!, $limit: Int!){
                cidades(nomeSearch: $nomeSearch, limit: $limit) {
                    id
                    nome
                    estado {
                        sigla
                    }
                }
            }
        `

        return this.cidadesPromise = this
            .gql
            .query(query, { nomeSearch: search, limit: 10 })
            .then(({ cidades }) => this.cidades = cidades)
    }

    certificadoSubmit() {
        this.certificadoForm.arquivo.$setValidity('vencido', true)
        this.certificadoForm.arquivo.$setValidity('arquivo', true)
        this.certificadoForm.senha.$setValidity('senha', true)
        this.certificadoForm.arquivo.$setValidity('cnpj', true)

        if (this.certificadoForm.$valid) {
            const { arquivo, senha } = this.certificado
            this.certificadoPromise = cbk
                .extractCertificado(arquivo, senha)
                .then(cert => {
                    this.certificadoForm.arquivo.$setValidity('vencido', cert.validade > new Date())

                    if (cert.cnpj) {
                        return this
                            .verificaExistencia(cert.cnpj.slice(0, 8))
                            .then(({ existe }) => this.certificadoForm.arquivo.$setValidity('cnpj', !existe))
                            .catch(() => null)
                            .then(() => cert)
                    } else {
                        return cert
                    }
                })
                .then(({ razaoSocial, cnpj, validade }) => {
                    if (this.certificadoForm.$valid) {
                        this.step = 'empresa'
                        this.certificado = { ...this.certificado, nome: arquivo.name, validade }

                        this.empresa = {
                            ...this.empresa,
                            razaoSocial,
                            cnpj,
                            cnpjExtraido: !!cnpj
                        }
                    }
                })
                .catch(err => {
                    if (err.message.match(/(invalid password)|(wrong password)/i)) {
                        this.certificadoForm.senha.$setValidity('senha', false)
                    } else {
                        this.certificadoForm.arquivo.$setValidity('arquivo', false)
                    }
                })
                .finally(() => this.apply())
        }
    }

    empresaSubmit() {
        if (this.empresaForm.$valid) {
            this.filial = { razaoSocial: this.empresa.razaoSocial }
            this.filiais = [{ ...this.empresa, matriz: true }, ...this.filiais].uniqBy(empresa => empresa.cnpj)

            if (this.empresa.cnpj.length == 14) {
                // CNPJ
                this.step = 'filiais'
            } else {
                // CPF
                this.step = 'confirmacao';
            }
        }
    }

    filialSubmit() {
        this.filialForm.finalCnpj.$setValidity('cnpj', this.filial.cnpj && cbk.validateCnpj(this.filial.cnpj))

        if (this.filialForm.$valid) {
            const filial = {
                ...this.filial,
                matriz: this.filial.cnpj === this.empresa.cnpj
            }

            this.filiais = [filial, ...this.filiais].uniqBy(empresa => empresa.cnpj)
            this.filial = { razaoSocial: this.empresa.razaoSocial }

            this.filialForm.$setPristine()
        }
    }

    next() {
        switch (this.step) {
            case 'certificado':
                this.certificadoForm.$setSubmitted()
                return this.certificadoSubmit()
            case 'empresa':
                this.empresaForm.$setSubmitted()
                return this.empresaSubmit()
            case 'filiais':
                return this.step = 'confirmacao'
            case 'confirmacao':
                this.termosUsoPrivacidadeForm.$setSubmitted()

                if (this.termosUsoPrivacidadeForm.$valid) {
                    this.submit()
                }
                return;
        }
    }

    previous() {
        switch (this.step) {
            case 'empresa':
                return this.step = 'certificado'
            case 'filiais':
                return this.step = 'empresa'
            case 'confirmacao':
                return this.step = 'filiais'
        }
    }

    removeFilial(filial) {
        this.filiais = this.filiais.reject(f => f === filial)
    }

    submit() {
        this.modal
            .open({
                component: 'progressoCadastroContratoModal',
                size: 'md',
                keyboard: false,
                backdrop: false,
                resolve: {
                    empresa: () => this.empresa,
                    certificado: () => this.certificado,
                    filiais: () => this.filiais
                }
            })
            .result
            .then(contrato => this.close({ $value: contrato.id }))
            .catch(console.error)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('cadastrarContratoModal', {
        controller: ['gql', '$scope', '$uibModal', CadastrarContratoModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <promise-tracker promise="$ctrl.promise" active="isLoading">
            <modal modal-title="Cadastrar nova empresa" close="$ctrl.close">
                <modal-body>
                    <div class="clearfix">
                        <highlighted>
                            <main>Novo por aqui?</main>
                            <secondary>Vamos começar cadastrando uma nova empresa.</secondary>
                        </highlighted>
                        <ef-wizard active="$ctrl.step">
                            <ef-wizard-step
                                id="certificado"
                                order="1"
                                icon="fa fa-archive"
                                label="Certificado A1">
                                <form name="$ctrl.certificadoForm" ng-submit="$ctrl.certificadoSubmit()" novalidate>
                                    <loading promise="$ctrl.certificadoPromise">
                                        <div class="row">
                                            <div class="form-group col-xs-12 col-sm-8">
                                                <label>Arquivo</label>
                                                <input 
                                                    class="btn btn-default btn-block" 
                                                    ngf-select 
                                                    type="file" 
                                                    accept=".pfx"
                                                    name="arquivo" 
                                                    ng-model="$ctrl.certificado.arquivo" 
                                                    ng-change="$ctrl.certificadoForm.$setPristine()"
                                                    required/>
                                                <div ng-messages="$ctrl.certificadoForm.arquivo.$error" ng-if="$ctrl.certificadoForm.$submitted">
                                                    <span 
                                                        class='help-block txt-color-red font-xs no-margin' 
                                                        ng-message="required">Este campo é obrigatório.
                                                    </span>
                                                    <span 
                                                        class='help-block txt-color-red font-xs no-margin' 
                                                        ng-message="arquivo">O arquivo selecionado é inválido.
                                                    </span>
                                                    <span 
                                                        class='help-block txt-color-red font-xs no-margin' 
                                                        ng-message="vencido">O certificado selecionado esta vencido.
                                                    </span>
                                                    <span 
                                                        class='help-block txt-color-red font-xs no-margin' 
                                                        ng-message="cnpj">Raiz do CNPJ contida no certificado já foi cadastrada.
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="form-group col-xs-12 col-sm-4">
                                                <label>Senha</label>
                                                <input 
                                                    type="password"
                                                    name="senha"
                                                    class="form-control"
                                                    ng-model="$ctrl.certificado.senha" 
                                                    ng-change="$ctrl.certificadoForm.$setPristine()"
                                                    required />
                                                <div ng-messages="$ctrl.certificadoForm.senha.$error" ng-if="$ctrl.certificadoForm.$submitted">
                                                    <span 
                                                        class='help-block txt-color-red font-xs no-margin' 
                                                        ng-message="required">Este campo é obrigatório.
                                                    </span>
                                                    <span 
                                                        class='help-block txt-color-red font-xs no-margin' 
                                                        ng-message="senha">A senha informada não é válida.
                                                    </span>
                                                </div>

                                                <button class="hidden"></button>
                                            </div>
                                        </div>
                                    </loading>
                                </form>
                            </ef-wizard-step> 

                            <ef-wizard-step
                                id="empresa"
                                order="2"
                                icon="fa-building"
                                label="Dados da empresa">
                                <form name="$ctrl.empresaForm" ng-submit="$ctrl.empresaSubmit()" novalidate>
                                    <loading promise="$ctrl.empresaPromise">
                                        <promise-tracker promise="$ctrl.cidadesPromise" active="isCidadeLoading">
                                            <div class="row">
                                                <div class="form-group col-xs-12 col-sm-4">
                                                    <label>CNPJ</label>
                                                    <input 
                                                        name="cnpj" 
                                                        class="form-control" 
                                                        ui-br-cpfcnpj-mask
                                                        ng-model="$ctrl.empresa.cnpj" 
                                                        ng-disabled="$ctrl.empresa.cnpjExtraido"                                                
                                                        required/>
                                                    <div ng-messages="$ctrl.empresaForm.cnpj.$error" ng-if="$ctrl.empresaForm.$submitted">
                                                        <span 
                                                            class='help-block txt-color-red font-xs no-margin' 
                                                            ng-message="required">Nenhum CNPJ foi informado.
                                                        </span>
                                                        <span 
                                                            class='help-block txt-color-red font-xs no-margin' 
                                                            ng-message="cnpj">O CNPJ informado não é válido.
                                                        </span>
                                                        <span 
                                                            class='help-block txt-color-red font-xs no-margin' 
                                                            ng-message="existe">A raiz do CNPJ informado já foi cadastrada.
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-group col-xs-12 col-sm-8">
                                                    <label>Razão social</label>
                                                    <input 
                                                        class="form-control"    
                                                        name="razaoSocial" 
                                                        ng-model="$ctrl.empresa.razaoSocial"
                                                        required />
                                                    <div ng-messages="$ctrl.empresaForm.razaoSocial.$error" ng-if="$ctrl.empresaForm.$submitted">
                                                        <span 
                                                            class='help-block txt-color-red font-xs no-margin' 
                                                            ng-message="required">Este campo é obrigatório.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="form-group col-xs-12 col-sm-4">
                                                    <label>Cidade</label>
                                                    
                                                    <span class="spinner" ng-if="isCidadeLoading">
                                                        <i class="fa fa-spin fa-circle-o-notch"></i>
                                                    </span>
                                                    
                                                    <ui-select 
                                                        theme="bootstrap" 
                                                        name="cidade" 
                                                        ng-model="$ctrl.empresa.cidade"
                                                        ng-class="{'spinner-select': isCidadeLoading}"
                                                        required>
                                                        <ui-select-match>
                                                            {{$select.selected.nome}} - {{$select.selected.estado.sigla}}
                                                        </ui-select-match>
                                                        <ui-select-choices 
                                                            repeat="cidade in $ctrl.cidades"
                                                            refresh="$ctrl.loadCidades($select.search)"
                                                            refresh-delay="500">
                                                            <div>{{cidade.nome}} - {{cidade.estado.sigla}}</div>
                                                        </ui-select-choices>
                                                    </ui-select>
                                                    <div ng-messages="$ctrl.empresaForm.cidade.$error" ng-if="$ctrl.empresaForm.$submitted">
                                                        <span 
                                                            class='help-block txt-color-red font-xs no-margin' 
                                                            ng-message="required">Nenhuma cidade foi selecionada.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </promise-tracker>
                                    </loading>
                                </form>
                            </ef-wizard-step> 

                            <ef-wizard-step
                                id="filiais"
                                order="3"
                                icon="fa-users"
                                label="Filiais">
                                <form name="$ctrl.filialForm" ng-submit="$ctrl.filialSubmit()" novalidate>
                                    <promise-tracker promise="$ctrl.cidadesPromise" active="isCidadeLoading">
                                        <loading class="loading-blurred" promise="$ctrl.filialPromise" active="isFilialLoading">
                                            <div class="well well-xs filial-form">
                                                <div class="row">
                                                    <div class="form-group col-xs-12 col-sm-4 col-md-3">
                                                        <label>CNPJ</label>
                                                        <div class="input-group">
                                                            <span class="input-group-addon">
                                                                {{$ctrl.empresa.raizCnpj | cpfCnpj}}
                                                            </span>
                                                            <input 
                                                                class="form-control" 
                                                                name="finalCnpj"
                                                                ng-model="$ctrl.filial.finalCnpj"
                                                                ng-disabled="isFilialLoading"
                                                                required/>
                                                        </div>
                                                        <div ng-messages="$ctrl.filialForm.finalCnpj.$error" ng-if="$ctrl.filialForm.$submitted">
                                                            <span 
                                                                class='help-block txt-color-red font-xs no-margin' 
                                                                ng-message="required">Nenhum CNPJ foi informado.
                                                            </span>
                                                            <span 
                                                                class='help-block txt-color-red font-xs no-margin' 
                                                                ng-message="cnpj">O CNPJ informado não é válido.
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="form-group col-xs-12 col-sm-8 col-md-9">
                                                        <label>Razão social</label>
                                                        <input 
                                                            class="form-control"    
                                                            name="razaoSocial" 
                                                            ng-model="$ctrl.filial.razaoSocial"
                                                            ng-disabled="isFilialLoading"
                                                            required />
                                                        <div ng-messages="$ctrl.filialForm.razaoSocial.$error" ng-if="$ctrl.filialForm.$submitted">
                                                            <span 
                                                                class='help-block txt-color-red font-xs no-margin' 
                                                                ng-message="required">Este campo é obrigatório.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div class="row">
                                                    <div class="form-group col-xs-12 col-sm-8 col-md-9">
                                                        <label>Cidade</label>
                                                        
                                                        <span class="spinner" ng-if="isCidadeLoading">
                                                            <i class="fa fa-spin fa-circle-o-notch"></i>
                                                        </span>

                                                        <ui-select 
                                                            theme="bootstrap" 
                                                            name="cidade" 
                                                            ng-model="$ctrl.filial.cidade"
                                                            ng-class="{'spinner-select': isCidadeLoading}"
                                                            reset-search-input="false"
                                                            required>
                                                            <ui-select-match>
                                                                {{$select.selected.nome}} - {{$select.selected.estado.sigla}}
                                                            </ui-select-match>
                                                            <ui-select-choices 
                                                                repeat="cidade in $ctrl.cidades"
                                                                refresh="$ctrl.loadCidades($select.search)"
                                                                refresh-delay="500">
                                                                <div>{{cidade.nome}} - {{cidade.estado.sigla}}</div>
                                                            </ui-select-choices>
                                                        </ui-select>
                                                        <div ng-messages="$ctrl.filialForm.cidade.$error" ng-if="$ctrl.filialForm.$submitted">
                                                            <span 
                                                                class='help-block txt-color-red font-xs no-margin' 
                                                                ng-message="required">Nenhuma cidade foi selecionada.
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="form-group col-xs-12 col-sm-4 col-md-3"> 
                                                        <label class="hidden-xs">&nbsp;</label>
                                                        <button class="btn btn-primary btn-block" ng-disabled="isFilialLoading">Adicionar filial</button>
                                                    </div>
                                                </div>
                                            </div>       
                                        </loading>                             
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <ul class="list-group no-margin">
                                                    <li class="list-group-item filial repeat-animation" ng-repeat="filial in $ctrl.filiais">
                                                        <span>{{filial.razaoSocial | limitToDots:80}} <small class="text-muted">{{filial.cnpj | cpfCnpj}}</small></span>
                                                        <div>
                                                            <span class="text-muted">{{filial.cidade.nome}} - {{filial.cidade.estado.sigla}}</span>                                                        
                                                            <abbr title="{{filial.matriz ? 'Não é possível remover a matriz' : 'Remover filial'}}">
                                                                <i ng-if="filial.matriz" class="fa fa-trash disabled"></i>
                                                                <i ng-click="$ctrl.removeFilial(filial)" ng-if="!filial.matriz" class="fa fa-trash remove"></i>
                                                            </abbr>
                                                        </div>                                            
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </promise-tracker>
                                </form>
                            </ef-wizard-step>

                            <ef-wizard-step
                                id="confirmacao"
                                order="4"
                                icon="fa-handshake-o"
                                label="Confirmação">
                                <div class="well well-xs no-margin">
                                    <h3 class="divider"><i class="fa fa-archive"></i> Certificado</h3>

                                    <b>Arquivo: </b> {{$ctrl.certificado.nome}}
                                    <br>
                                    <b>Validade: </b> {{$ctrl.certificado.validade | date: 'dd/MM/yyyy'}}                                        

                                    <h3 class="divider"><i class="fa fa-building"></i> Empresa</h3>

                                    <b>Razão social: </b> <span>{{$ctrl.empresa.razaoSocial}}</span>
                                    <br>
                                    <b>Raiz CNPJ: </b> <span>{{$ctrl.empresa.cnpj.slice(0, 8) | cpfCnpj}}</span>
                                

                                    <h3 class="divider"><i class="fa fa-users"></i> Filiais</h3>
                                        
                                    <div ng-repeat="filial in $ctrl.filiais" class="filial">
                                        <b>Razão social: </b><span>{{filial.razaoSocial}}</span>
                                        <br>
                                        <b>CNPJ: </b><span>{{filial.cnpj | cpfCnpj}}</span>
                                        <br>
                                        <b>Cidade: </b><span>{{filial.cidade.nome }} - {{filial.cidade.estado.sigla}}</span>
                                    </div>
                                </div>
                                <form class="termos" name="$ctrl.termosUsoPrivacidadeForm" novalidate>
                                    <div>
                                        <label>
                                            <input
                                                type="checkbox"
                                                class="checkbox"
                                                ng-model="$ctrl.termosUso"
                                                required/>
                                            <span> Li e concordo com os 
                                                <a href="/assets/files/termos_de_uso.pdf" target="_blank">
                                                    <b>termos de uso.</b>
                                                </a>
                                            </span>
                                        </label>
                                    </div>
                                    <div>
                                        <label>
                                            <input
                                                type="checkbox"
                                                class="checkbox"
                                                ng-model="$ctrl.politicaPrivacidade"
                                                required/>
                                            <span> Li e concordo com a 
                                                <a href="/assets/files/politica_de_privacidade.pdf" target="_blank">
                                                    <b>política de privacidade.</b>
                                                </a>
                                            </span>
                                        </label>
                                    </div>
                                    <div ng-show="$ctrl.termosUsoPrivacidadeForm.$invalid && $ctrl.termosUsoPrivacidadeForm.$submitted">
                                        <span class='help-block txt-color-red font-xs no-margin'>
                                            Você deve concordar com os termos de uso e a política de privacidade para continuar.
                                        </span>
                                    </div>
                                </form>
                            </ef-wizard-step>
                        </ef-wizard>
                    </div>
                </modal-body>
                <modal-footer>
                    <button 
                        class="btn btn-default"
                        type="button"
                        ng-click="$ctrl.previous()" 
                        ng-if="$ctrl.step != 'certificado'" 
                        ng-disabled="isLoading">
                        Voltar
                    </button>
                    <button 
                        class="btn btn-primary" 
                        type="button" 
                        ng-click="$ctrl.next()"
                        ng-disabled="isLoading">
                        <span ng-if="$ctrl.step != 'confirmacao'">Avançar</span>
                        <span ng-if="$ctrl.step == 'confirmacao'">Salvar</span>
                    </button>
                </modal-footer>
            </modal>
        </promise-tracker>
        `
    })
